module.exports = __webpack_public_path__ + "files/e7cef962bc5d364dc45f63c9c164aa8a.png";